export const LinkForwardIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3938 7.08089L12.9199 5.60174C11.8578 4.53599 11.4415 3.96268 10.8664 4.16536C10.1494 4.41808 10.3854 6.01269 10.3854 6.55103C9.27053 6.55103 8.1114 6.45194 7.01239 6.6584C3.38444 7.33998 2.25 10.2865 2.25 13.5C3.27682 12.7727 4.30262 11.9978 5.53675 11.6607C7.07728 11.2399 8.7978 11.4407 10.3854 11.4407C10.3854 11.979 10.1494 13.5737 10.8664 13.8263C11.5181 14.056 11.8578 13.4557 12.9199 12.3899L14.3938 10.9108C15.298 10.0035 15.75 9.5499 15.75 8.99588C15.75 8.44185 15.298 7.98818 14.3938 7.08089Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
